import http from "./httpService";
import jwtDecode from "jwt-decode";
import md5 from 'md5';
import { detect } from 'detect-browser'
const browser = detect();
const Urlapi = "https://api-mobileapp.advanceagro.net";
const apiEndpoint = "/wms";
const tokenKey = "wms_token"; 
const branchKey = "_id";
const branchName = "_name";
//const currentBranch = {_id:'',name:""};ttps://maxmobile.advanceagro.net/ws2/api

const permission = "permission"

http.setJwt(getJwt());

export async function login(account, password) {

  try {
    const device = (browser) ? `${browser.name} [OS=${browser.os}][V=${browser.version}]` : "Unknown"

    const data = { account: account, password: md5(password), role: 'web', device};
    const { data: result } = await http.post("/wms/authen", data);
    if ( result.status === 'success') {

      const jwt = result.data.token;
      localStorage.setItem(tokenKey, jwt);
    
      return {result:"OK",token:jwt};
    } else {
      return result.message;
    }
  } catch(err) {
    return err.message;
  }
  
}

export function loginWithJwt(jwt) {
  localStorage.setItem(tokenKey, jwt);
  
}

export function  getCurrentUser()   {
  try {
    const jwt = localStorage.getItem(tokenKey);
    return jwtDecode(jwt);
  } catch (ex) {
    return undefined;
  }
}


export function  getCurrentUser2()   {
  try {
    const jwt = localStorage.getItem(tokenKey);
    return jwtDecode(jwt);
  } catch (ex) {
    return {empid:""};
  }
}



export function getCurrentBranchID () {
 // console.log('current branch key',branchKey);
  try {
    const _id = localStorage.getItem(branchKey);
    return {_id};
  } catch (ex) {
    return undefined;
  }

}

export function getCurrentBranchName () {

  try {
    const name = localStorage.getItem(branchName);
    return {name};
  } catch (ex) {
    return undefined;
  }

}

export function setCurrentBranchID(selectBranch) {
  localStorage.setItem(branchKey,selectBranch);
}
export function setCurrentBranchName(selectBranch) {
  localStorage.setItem(branchName,selectBranch);
}
export function getCurrentBranch() {
  const _id = localStorage.getItem(branchKey);
  const name = localStorage.getItem(branchName);
  return {_id,name};

}
export function getJwt() {
  
  return localStorage.getItem(tokenKey);
  
}

export async function GetBranch() {
  const token = getJwt()
    http.setJwt(token); 
//  http.getaxios.defaults.headers["x-auth-token"] = token
  return http.get("/wms/GetBranch");
}

export function logout() {
  localStorage.removeItem(tokenKey);
}
export async function loadPermission() {

  try {
    const user = getCurrentUser()   
  
    if(!user || !user.empid) return undefined
    const jwt = localStorage.getItem(tokenKey);
    if (!jwt) return undefined
    http.setJwt(jwt); 
    const {_id} = getCurrentBranch()
    const { data: result } = await getMemulist(_id);
    

    if(result){
 
      return result;
    }

  } catch (error) {
    return {status: 'error', message: error.message}
  }
}
export function getPermission() {
  const value = localStorage.getItem(permission)
  try {
    return JSON.parse(value)
  } catch(err) {
    return undefined
  }
}

export async function loadMenulByToken(token) {
  try {
   
    const jwt = token
    if (!jwt) return undefined
    http.setJwt(jwt); 
    const {_id} = getCurrentBranch()
    const { data: result } = await getMemulist(_id);
    if(result){
      return result;
    }
  } catch (error) {
    return {status: 'error', message: error.message}
  }
}

export async function getMemulist(branchid) {
  return http.get(Urlapi + "/wms/menu/" + branchid);
}

export default {
  login,
  loginWithJwt,
  logout,
  getCurrentUser,
  getJwt,
  getCurrentBranchID,
  getCurrentBranchName,
  setCurrentBranchID,
  setCurrentBranchName,
  getCurrentBranch,getMemulist,getPermission,loadMenulByToken,getCurrentUser2
};
